export default __webpack_public_path__ + "static/media/KRUSKALExp.e968cbbd.md";